import React, { useEffect, useState } from 'react';
import {
  generatePath,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom';
import ReportYearRead from './ReportYearRead';
import ReportYearEdit from './ReportYearEdit';

export default function ReportYear(props) {
  const location = useLocation();
  const history = useHistory();
  const [isEditMode, setIsEditMode] = useState(false);
  const [year, setYear] = useState(props.reportYear);

  const yearMatcher = useRouteMatch('*/(yearReport|report)/year/:reportYear*');

  useEffect(() => setIsEditMode(location.search.includes('edit=1')), [location.search]);

  const changeYear = (newYear) => {
    const route = yearMatcher.path;

    const path = generatePath(route, {
      ...yearMatcher.params,
      reportYear: newYear,
    });
    history.replace({
      search: location.search,
      pathname: path,
    });
    setYear(newYear);
  };

  return isEditMode
    ? <ReportYearEdit {...props} year={year} changeYear={changeYear} />
    : <ReportYearRead {...props} year={year} changeYear={changeYear} project={props.project}/>;
}
